import { useEffect, useState } from 'react';

import { Button, Input, Text } from 'components';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

interface Props {
  email: string;
  name : string;
  company: string; 
  country : string;
  purpose : string;
}

const InfoText = () => {
  return (
    <div className="w-full text-center">
      <Text className="inline-block" size="small" color="primary" weight="regular">
        {`Haven't received an email? Please check your spam folder or contact us at:`}
        <a className="ml-1 text-system100" href="mailto:iopsspace@i-ops.co.kr">
          iopsspace@i-ops.co.kr
        </a>
      </Text>
    </div>
  );
};

const ConfirmForm = ({ email, name, company , country, purpose }: Props) => {
  const [confirmCode, setConfirmCode] = useState<string>('');
  const [isConfirmed, setIsConfirmed] = useState<boolean>(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(true);
  const [message, setMessage] = useState<string>('');
  const [subText, setSubText] = useState<string>('');
  const nav = useNavigate();

  // 인증 코드 확인 및 API 요청 함수
  const onClickConfirmButton = async () => {
    if (!isConfirmed && !isButtonDisabled) {
      setSubText(''); 
      console.log('이메일',email);
      console.log('confirmCode',confirmCode);
      try {
        const res = await axios.post('/api/member/checkEmailToken', { email, token: confirmCode });
        console.log('res', res);
        if (res.status === 200) {
          console.log('성공함');
          setIsConfirmed(true);
          setSubText('Your account is successfully generated.');
          // 2초 후 로그인 페이지로 이동
          setTimeout(() => {
          nav('/login');
        }, 2000);
        } else if (res.status === 204) {
          setSubText('Invalid confirmation code. Please try again.');
        }
      } catch (error) {
        console.error('Verification failed', error);
        setSubText('Verification failed. Please try again.');
      }
    } else {
      nav('/'); // 홈 페이지로 이동
    }
  };

  useEffect(() => {
    if (isConfirmed) {
      setIsButtonDisabled(false);
      return;
    }
    if (confirmCode.length > 0) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  }, [confirmCode, isConfirmed]);

  return (
    <div className="flex w-80 flex-col items-center">
      <Text className="mb-1" size="heading2" weight="medium">
        {isConfirmed ? 'Congraturations!' : 'Confirm your email'}
      </Text>
      <Text className="mb-6 w-full text-center" size="body2" weight="regular" color="secondary">
        {isConfirmed
          ? 'Your account is successfully generated.'
          : `A verification code has been sent to you at ${email}`}
      </Text>
      {!isConfirmed && (
        <form className="mb-6 flex w-full flex-col ">
          <Input
            inputClassName="bg-white h-10"
            type="text"
            value={confirmCode}
            setValue={setConfirmCode}
            subText={subText}
          />
        </form>
      )}
      <Button
        className="mb-6 h-10 w-full items-center justify-center"
        text={isConfirmed ? 'Go to home' : 'Confirm email'}
        type="blue"
        disabled={isButtonDisabled}
        onClick={onClickConfirmButton}
      />
      <InfoText />
    </div>
  );
};

export default ConfirmForm;
